import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getHomePath } from '../../utils/permissions';
import LoadingSpinner from '../LoadingSpinner';

/**
 * PublicRoute - Route wrapper that redirects authenticated users to their dashboard
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render if not authenticated
 * @param {string} [props.tier] - Expected tier for this login page ('tenant' or 'platform')
 * @returns {React.ReactNode}
 */
export const PublicRoute = ({ children, tier }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    // If user is authenticated, redirect to their home
    const homePath = getHomePath(user);
    return <Navigate to={homePath} replace />;
  }

  return children;
};

export default PublicRoute;
